import type {RefinementCtx} from 'zod';

import {isNotNil} from 'ramda';

import type {CheckoutProfileRuleWrite} from '../types';

export function validateCheckoutProfileRule(
  rule: CheckoutProfileRuleWrite,
  context: RefinementCtx
) {
  const serviceFields = [
    'serviceCaseTypeIds',
    'serviceOrderTypeIds',
    'serviceOrderVariantIds',
  ] as const;

  const directFields = [
    'authorizationProfileIds',
    'directSaleTypeIds',
    'directSaleVariantIds',
  ] as const;

  const forbiddenFields = rule.sourceType === 'service-order' ? directFields : serviceFields;
  forbiddenFields.forEach((field) => {
    if (isNotNil(rule.conditions[field])) {
      context.addIssue({
        code: 'custom',
        path: ['conditions', field],
        message: 'CONDITION_NOT_FOR_SOURCE',
      });
    }
  });

  const allowedFields = rule.sourceType === 'service-order' ? serviceFields : directFields;
  const [firstType, secondType, variants] = allowedFields;

  if (isNotNil(rule.conditions[variants])) {
    [firstType, secondType].forEach((field) => {
      if (isNotNil(rule.conditions[field])) {
        context.addIssue({
          code: 'custom',
          path: ['conditions', field],
          message: 'VARIANT_EXCLUDES_TYPES',
        });
      }
    });
  }
}
